export const serializeManagerEmail = ({
  id,
  from,
  to,
  subject,
  message,
  show_url: link,
  download_url: downloadLink,
  created_at: createdAt,
}) => ({
  id: String(id),
  from,
  to,
  subject,
  body: message,
  link,
  downloadLink,
  createdAt,
});
